
(function () {
  function updateFlashTimers() {
    document.querySelectorAll('[data-flash-future]').forEach(function (message) {
      var deadline = Date.parse(message.dataset.deadline);
      message.hidden = !Number.isFinite(deadline) || deadline <= Date.now();
    });
    document.querySelectorAll('.mq-flash-countdown').forEach(function (timer) {
      var deadline = Date.parse(timer.dataset.deadline);
      var output = timer.querySelector('.mq-flash-time');

      if (!Number.isFinite(deadline) || !output) return;

      var remaining = Math.max(0, deadline - Date.now());

      if (remaining === 0) {
        timer.hidden = true;
        return;
      }

      var seconds = Math.floor(remaining / 1000);
      var days = Math.floor(seconds / 86400);
      var hours = Math.floor((seconds % 86400) / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      output.textContent =
        pad(days) + 'g : ' +
        pad(hours) + 'h : ' +
        pad(minutes) + 'm : ' +
        pad(secs) + 's';

      timer.hidden = false;
    });
  }

  function startFlashTimers() {
    updateFlashTimers();

    if (!window.mqFlashTimerInterval) {
      window.mqFlashTimerInterval = setInterval(updateFlashTimers, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFlashTimers);
  } else {
    startFlashTimers();
  }

  document.addEventListener('shopify:section:load', updateFlashTimers);
})();

